// extracted by mini-css-extract-plugin
export default {"actionButton":"IntegrationPanelActionButton_actionButton__b442C"};